export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PACKAGES = [
  {
    id: "exterior",
    name: "The Exterior Valet",
    priceMin: 99,
    priceMax: 129,
    duration: "Exterior only · Approx. 1.5–2 hours",
    tagline: "Professional exterior care for a clean, glossy finish",
    features: [
      "Snow-foam pre-wash & two-bucket hand wash",
      "Wheels, tires & wheel wells thoroughly cleaned",
      "Bug & road grime removal",
      "Door jambs cleaned",
      "Exterior glass & mirrors cleaned",
      "Tires dressed + exterior trim cleaned & dressed",
      "Spray sealant for added gloss & protection",
      "Hand dried with premium microfiber towels",
      "Final exterior inspection & finishing touches",
    ],
  },
  {
    id: "interior",
    name: "The Interior Valet",
    priceMin: 119,
    priceMax: 135,
    duration: "Interior only · Approx. 2–3 hours",
    tagline: "Complete interior refresh for your daily driver",
    features: [
      "Full interior vacuum — seats, carpets & mats",
      "Dashboard, console & door panels cleaned",
      "Cupholders, vents & crevices detailed",
      "Interior trim cleaned & dressed",
      "Streak-free interior glass & mirrors",
      "Floor mats deep cleaned",
      "Leather seats cleaned & conditioned (if applicable)",
      "Light spot & stain treatment",
      "Interior deodorized + door jambs wiped",
      "Final interior inspection & finishing touches",
    ],
  },
  {
    id: "signature",
    name: "The Signature Detail",
    priceMin: 199,
    priceMax: 259,
    duration: "Complete interior + exterior · Approx. 4 hours",
    tagline: "Our complete inside-and-out transformation",
    popular: true,
    features: [
      "Everything included in The Interior Valet",
      "Everything included in The Exterior Valet",
      "Deep carpet & upholstery cleaning/extraction",
      "Vents, crevices & hard-to-reach areas detailed",
      "Leather deep cleaned & conditioned (if applicable)",
      "Iron & light tar decontamination",
      "Paint sealant — up to 6 months of protection",
      "Exterior trim cleaned & dressed",
      "Enhanced tire & wheel finishing",
      "Steam cleaning/sanitization where appropriate",
      "Final interior & exterior inspection",
    ],
  },
  {
    id: "premier",
    name: "The Premier Obsidian",
    priceMin: 399,
    priceMax: 499,
    duration: "Premium full detail · Approx. 6–8 hours",
    tagline: "The ultimate Valet Premier treatment — restoration, enhancement, and protection",
    features: [
      "Everything included in The Signature Detail",
      "Single-stage machine polish — enhanced gloss, reduced swirls",
      "Full paint decontamination before polishing",
      "12-month ceramic protection on exterior paint",
      "Engine bay cleaned & dressed",
      "Deep carpet & upholstery extraction",
      "Detailed steam cleaning throughout interior",
      "Premium leather cleaning & conditioning (if applicable)",
      "Wheels, tires & wheel wells deep cleaned & dressed",
      "Exterior trim restored & protected",
      "Premium finishing touches throughout",
      "Final multi-point inspection",
    ],
  },
];

export const TIME_SLOTS = ["08:00 AM", "10:30 AM", "01:00 PM", "03:30 PM"];

export const GIFT_AMOUNTS = [50, 100, 250, 500];

export const DEPOSIT = 50;

const P = "https://videos.pexels.com/video-files";
export const MEDIA = {
  heroVideo: `${P}/6873168/6873168-uhd_2560_1440_25fps.mp4`,
  heroPoster:
    "https://images.unsplash.com/photo-1608506375591-b90e1f955e4b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  gallery: [
    {
      src: `${P}/6873325/6873325-sd_640_360_25fps.mp4`,
      title: "Foam Cannon Baptism",
      caption: "Snow-foam dwell dissolving road film",
      wide: true,
    },
    {
      src: `${P}/6873164/6873164-sd_360_640_25fps.mp4`,
      title: "The Hand-Dry Sheen",
      caption: "Heated microfiber, zero water spots",
    },
    {
      src: `${P}/32010530/13643296_360_640_30fps.mp4`,
      title: "Wheel & Caliper Ritual",
      caption: "Brush-worked barrels to a mirror",
    },
    {
      src: `${P}/32010533/13643220_360_640_30fps.mp4`,
      title: "Interior Steam Revival",
      caption: "Deep extraction & cabin sanitation",
    },
    {
      src: `${P}/6872063/6872063-sd_640_360_25fps.mp4`,
      title: "Pressure Rinse Finale",
      caption: "Touchless rinse, panel-perfect finish",
      wide: true,
    },
  ],
};

export const CHAPTERS = [
  {
    n: "01",
    title: "Professional Mobile Detailing",
    sub: "Premium detailing, brought directly to you.",
    text: "We arrive fully equipped with our own water, power, professional equipment and detailing products. Whether you're at home or work, we make getting your vehicle detailed simple and convenient.",
  },
  {
    n: "02",
    title: "Interior & Exterior Care",
    sub: "Complete care, inside and out.",
    text: "From deep interior cleaning and extraction to hand washing, wheels, tires and paint protection, every part of your vehicle receives careful attention.",
  },
  {
    n: "03",
    title: "Paint Enhancement & Protection",
    sub: "Restore the gloss. Protect the finish.",
    text: "Professional decontamination, machine polishing and protective treatments help remove embedded contamination, reduce light swirls and restore depth and shine to your paint.",
  },
  {
    n: "04",
    title: "We Come to You",
    sub: "Your driveway becomes our detailing studio.",
    text: "No waiting rooms. No dropping off your vehicle. Valet Premier Detailing brings the equipment, water and power directly to your home or workplace.",
  },
];
